import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from '@services/config.service';
import { DeliveryService } from '@services/delivery.service';
import { NotificationService } from '@services/notification.service';
import { Subscription } from 'rxjs';
import { AppService } from '../../services/app.service';
import { ExamineeloginService } from '../../services/examineelogin.service';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { assessmentTypeId } from '@configs/assessment.config';

@Component({
  selector: 'app-examinee-login',
  templateUrl: './examinee-login.component.html',
  styleUrls: ['./examinee-login.component.scss']
})
export class ExamineeLoginComponent implements OnInit {

  loginForm: FormGroup;
  isSubmitted = false;
  loginSpinner = false;
  submitted = false;
  loginErrorMessage: string;
  isLoginError = false;
  userServiceSubscription$: Subscription;
  scheduleDetail$: Subscription;
  publicLogin$: Subscription;
  schuid: any;
  testbankuuId: any;
  testDetails: any;
  schId: any;
  scheduleData: any;
  scheduleType: any;
  queryString: any;
  err: string;
  captchaData$: Subscription;
  validateCaptcha$: Subscription;
  checkUser$: Subscription;
  CaptchaImgUrl: any;
  CaptchaTextValue: any;
  CaptchaTokenValue: any;
  isValid: any;
  Interval: any;
  disableForgotPass: boolean = false;
  isGetDemographic: boolean = false;
  lmsParam: any[];
  asValueinQueryString: boolean = false;
  smallDescription: any;
  isConsentFill: boolean = false;
  assessmentTypeIds: any;
  lockoutMsg: boolean = false;
  fullyear = new Date().getFullYear();
  constructor(private fb: FormBuilder, private appService: AppService,
    private examineeloginservice: ExamineeloginService,
    private routerstate: ActivatedRoute,
    private deliveryService: DeliveryService, private router: Router,
    private notificationService: NotificationService,
    public configService: ConfigService,
    public translate: TranslateService,

    private webErrorService: WebErrorService) {
      this.lmsParam = ['enrollmentid', 'assessmentid', 'classid', 'userid', 'assignmentid']
      this.assessmentTypeIds = assessmentTypeId
    }

  ngOnInit(): void {
    this.CaptchaImgUrl = '../../../assets/favicon/images.jfif';
    // this.styleService.addStyle('login', require('../../../scss/login.css'));
    this.routerstate.paramMap.subscribe(data => {
      this.schId = data.get('id');
    });

    this.routerstate.queryParams.subscribe(params => {
      this.queryString = params;
      localStorage.setItem('test-language', this.queryString.language);
    });

    if (this.schId) {
      this.scheduleDetail$ = this.examineeloginservice
        .scheduleDetail(this.schId, this.queryString.patientuuid, this.queryString.language).subscribe((data: any) => {
          this.scheduleData = data;
          this.scheduleType = this.scheduleData?.scheduleType;

          localStorage.setItem('test-language', this.scheduleData?.languageCode);
          if (localStorage.getItem('test-language')) {
            let lng=localStorage.getItem('test-language')
            this.translate.use(lng);
            if(this.scheduleData?.languageCode==="es-ES") {
              this.smallDescription = this.configService.themeConfig.DescSpanish
            }
            else if(this.scheduleData?.languageCode==="pt-PT") {
              this.smallDescription = this.configService.themeConfig.DescPortugese;
            }
            else {
              this.smallDescription = this.configService.themeConfig.Description;
            }

                // if(this.scheduleData?.langId === "4"){
                //   localStorage.setItem('test-language', "es-ES");
                //   if (localStorage.getItem('test-language')) {
                //     let lng=localStorage.getItem('test-language')
                //     this.translate.use(lng);
                //     this.smallDescription = this.configService.themeConfig.DescSpanish
                //    }
                // } else if(this.scheduleData?.langId === "9"){
                //   localStorage.setItem('test-language', "pt-PT");
                //   if (localStorage.getItem('test-language')) {
                //     let lng=localStorage.getItem('test-language')
                //     this.translate.use(lng);
                //     this.smallDescription = this.configService.themeConfig.DescPortugese
                //    }
                // }
                // else{

                //   if (localStorage.getItem('test-language')) {
                //     let lng=localStorage.getItem('test-language')
                //     this.translate.use(lng);
                //     this.smallDescription = this.configService.themeConfig.Description
                //   }
          }
          if (this.scheduleType == "Public") {
            this.routerstate.queryParams
              .subscribe(params => {
                this.queryString = params;
              });

            let result = Object.assign({}, this.queryString); // clone so we don't modify the original.
            delete result['patientuuid'];
            result['uuid'] = this.queryString['patientuuid'];
            this.queryString = '';
            this.queryString = result;

            Object.keys(this.queryString).find(key => {
              if (key) this.asValueinQueryString = true;
              if (this.lmsParam.includes(key)) this.isGetDemographic = false;
            })

            // if (this.asValueinQueryString && this.isGetDemographic) {
            //   this.router.navigate(['/Page-Not-Found']);
            //   return;
            // }
            //Call API and pass scheduleid and querystring
            // this.queryString = {"uuid": "5a23-4148-bb48"}

            this.publicLogin$ = this.examineeloginservice.publicLogin(this.schId, this.queryString, this.isGetDemographic)
              .subscribe(
                (data: any) => {
                  sessionStorage.setItem('assessmentType', data.body.data.assessmentTypeId);
                  if (!data.body.data.isConsentDone && data.body.data.assessmentTypeId == assessmentTypeId.patientAssisted) { // add assessmenttype condition
                    this.router.navigate(['/delivery/consentForm', this.schId]); // only for Patient
                  } else {
                    this.deliveryService.getExamineeTest(this.schId).subscribe(resData => {
                      sessionStorage.setItem('scheduleEndDate', resData.scheduleEndDate);
                      this.testDetails = resData;
                      this.testbankuuId = this.testDetails?.testbankuuId;
                      sessionStorage.removeItem('publicParameters');
                      this.router.navigate(['/delivery/start/test', this.testbankuuId]);
                    }, (error: any) => {
                      this.webErrorService.handleAPIErrors(error, null, true, 'warn');
                    });
                  }
                }, (error: any) => {
                  if ( Object.keys(this.queryString).find(key => Array.isArray(this.queryString[key]) && this.queryString[key].length > 1)) {
                    this.webErrorService.handleAPIErrors(error, 'Incorrect user parameter', true, 'warn');
                  } else {
                    this.webErrorService.handleAPIErrors(error, null, true, 'warn');
                  }
                });
          } else {
            this.GetCaptcha();

            this.Interval= setInterval(() => {
              this.GetCaptcha();
            }, 300000);
          }

        }, (error: any) => {
          this.webErrorService.handleAPIErrors(error);
        });
    }
    this.loginForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      captchaText: ['', Validators.required]
    });
    // if (localStorage.getItem('test-language')) {
    //   let lng=localStorage.getItem('test-language')
    //   this.translate.use(lng);
    //  }
    this.appService.changeUserHeader(0);
  }

  GetCaptcha() {
    if(this.captchaData$){this.captchaData$.unsubscribe();}
    this.captchaData$= this.examineeloginservice.getCaptcha()
    .subscribe(data => {
    if(data) {
      this.CaptchaImgUrl = data.dntCaptchaImgUrl;
      this.CaptchaTokenValue = data.dntCaptchaTokenValue;
      this.CaptchaTextValue = data.dntCaptchaTextValue;
    }
    })
  }

  resendCaptcha() {
    this.GetCaptcha();
  }

  get f(): any {
    return this.loginForm.controls;
  }

  login(): void {
    this.lockoutMsg = false;
    this.loginErrorMessage = "";
    //this.loginSpinner = true;
    this.submitted = true;
    if (this.loginForm.valid) {
      this.isValid = true;
      if(this.validateCaptcha$){this.validateCaptcha$.unsubscribe();}
      this.validateCaptcha$= this.examineeloginservice.validateCaptcha(this.CaptchaTokenValue, this.CaptchaTextValue, this.loginForm.value.captchaText)
      .subscribe((res)=>{
        if(res && res.status === "true") {
          if( this.checkUser$){ this.checkUser$.unsubscribe();}
          this.checkUser$= this.examineeloginservice.checkUser(this.loginForm.value.email, this.loginForm.value.password, this.schId)
          .subscribe((res)=>{
            let d = {email: res.data.emailId, userID: res.data.examineeId, password: this.loginForm.value.password, isTempPassword: res.data.isTempPassword, schId: this.schId}
            localStorage.setItem('userData', JSON.stringify(d));

            if (res.data.isTempPassword == false && res.data.isTwoFactorAuthentication == false) {
              this.loginFun();
            } else if (res.data.isTempPassword == true && res.data.isTwoFactorAuthentication == false) {
              this.router.navigate(['/change-Passwordd']);
            }
            else {
              this.router.navigate(["td/twoFactorAuthD", this.schId]);
            }
          },(error: any)=>{
            this.resendCaptcha();
            this.loginErrorMessage = error.error.message;
            if (this.loginErrorMessage.match(this.translate.instant('userLogin.loginForm.errorMsg'))) {
              this.disableForgotPass = true;
              this.lockoutMsg = true;
            }
            this.isValid = false;
          })
          // this.userServiceSubscription$ = this.examineeloginservice
          // .login(this.loginForm.value.email, this.loginForm.value.password, this.schId)
          // .subscribe(
          //   (data: any) => {
          //     this.deliveryService.getExamineeTest(this.schId).subscribe(resData => {
          //       this.testDetails = resData;
          //       this.testbankuuId = this.testDetails?.testbankuuId;
          //       this.router.navigate(['/delivery/start/test', this.testbankuuId]);
          //     }, (error: any) => {
          //       this.webErrorService.handleAPIErrors(error, null, true, 'warn');
          //     });
          //   }, (error: any) => {
          //     this.loginErrorMessage = error.error.message;
          //
        } else {
          this.resendCaptcha();
          this.isValid = false;
          this.loginErrorMessage = res.message;
        }
      },(error: any)=>{
        this.loginErrorMessage = error.error.message;
      })

    }
  }

  loginFun() {
    let payload = {
      "emailId": this.loginForm.value.email,
      "password": this.loginForm.value.password,
      // "authorizationCode": this.twoFactorAuth.value.code,
      "testscheduleuuid": this.schId
    }

    this.userServiceSubscription$ = this.examineeloginservice.signIn(payload).subscribe((data) => {
      if (data.status != false) {
        this.deliveryService.getExamineeTest(this.schId).subscribe(resData => {
          this.testDetails = resData;
          this.testbankuuId = this.testDetails?.testbankuuId;
          this.router.navigate(['/delivery/start/test', this.testbankuuId]);
        }, (error: any) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
      } else {
        this.isValid = false;
        this.loginErrorMessage = data.message;
      }
    }, (error: any) => {
      this.isValid = false;
      this.loginErrorMessage = error.error.message;
    });
  }

  resetPwd(): void {
    this.router.navigate(['./reset-examinee-password'])
  }
  ngOnDestroy() {
    // this.styleService.removeStyle('login');
    if(this.captchaData$){this.captchaData$.unsubscribe();}
    if( this.checkUser$){ this.checkUser$.unsubscribe();}
    if(this.validateCaptcha$){this.validateCaptcha$.unsubscribe();}
    if(this.Interval){clearInterval(this.Interval)}
    }
  }

